import { NO_PREF } from "@overbookd/preference";
//#region src/mime.ts
const JSON = "application/json";
const CSV = "text/csv";
const ICAL = "text/calendar";
const PDF = "application/pdf";
//#endregion
//#region src/registration.ts
const registrationSteps = {
	LOGIN: "LOGIN",
	FORM: "FORM",
	COMPLETED: "COMPLETED"
};
const hasHttpStringifiedRegistrationFormData = (step) => {
	return step.next === registrationSteps.FORM && "accountStatus" in step;
};
const hasRegistrationFormData = (step) => {
	return step.next === registrationSteps.FORM && "accountStatus" in step;
};
//#endregion
//#region src/preference.ts
const DEFAULT_PREFERENCE = {
	paperPlanning: null,
	assignment: NO_PREF,
	favoritePages: []
};
//#endregion
//#region src/image.ts
const IMAGE_MAX_SIZE = 524288;
const IMAGE_EXTENSIONS = [
	"image/png",
	"image/jpeg",
	"image/webp",
	"image/gif"
];
//#endregion
export { CSV, DEFAULT_PREFERENCE, ICAL, IMAGE_EXTENSIONS, IMAGE_MAX_SIZE, JSON, PDF, hasHttpStringifiedRegistrationFormData, hasRegistrationFormData, registrationSteps };

//# sourceMappingURL=index.mjs.map